<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">ACKNOWLEDGEMENTS</p>
<p class="noindent">I would like to thank Kevin T. Kelly, Ethan Schrage, Ann Schrage, Paul Tenkotte, Rick Pender, the staff of the Cincinnati/Hamilton County Public Library, Kenton County Public Library, the Price Hill Historical Society, the Cincinnati History Library and Archives at Cincinnati Museum Center and the Taft Museum of Art.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Acknowledgements.vue?40b8551f